export function getEnglishOrdinal(n: number): string {
  const s = ["th", "st", "nd", "rd"]
  const v = n % 100
  return n + (s[(v - 20) % 10] || s[v] || s[0])
}

export function getUkrainianOrdinal(n: number): string {
  return n === 3 ? `${n}-є` : `${n}-е`
}

export function getRussianOrdinal(n: number): string {
  return `${n}-е`
}
